import { useState } from "react";
import ImageUploader from "../../component/InventoryUI/ImageUploader";
import { useQrAuth } from "../../context/QrAuth";
import fetcher from "../../helper/fetcher";
import { useSnackbar } from "../../context/SnackBarContext";
import Button from "@mui/material/Button";
import { imageBaseUrl } from "../../utils/utils";

export default function EditProfileForm({ setDrawerOpen }) {
  const { user, setUser } = useQrAuth();
  const { showSuccess, showError } = useSnackbar();
  const [isLoading, setIsLaoding] = useState(false)

  const [editFormData, setEditFormData] = useState({
    image: user?.profile_image?.startsWith("https")
      ? user?.profile_image
      : imageBaseUrl + "images/" + `${user?.profile_image}`,
    name: user?.name,
    title: user?.title,
    company: user?.company,
    telephone: user.telephone,
    email: user?.email,
    address: user?.address,
    linkedin: user?.linkedin,
    website: user?.website,
  });
  const [error, setError] = useState("");

 const validateForm = () => {
    if (!editFormData.name?.trim()) {
      showError("Name is required");
      return false;
    }

    if (!editFormData.telephone?.trim()) {
      showError("Phone number is required");
      return false;
    }
    if (!/^[0-9]{10}$/.test(editFormData.telephone)) {
      showError("Enter a valid 10-digit phone number");
      return false;
    }

    if (!editFormData.email?.trim()) {
      showError("Email is required");
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editFormData.email)) {
      showError("Enter a valid email address");
      return false;
    }

    return true;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditForm = () => {
    if (!validateForm()) {
      return;
    }

    if (user?._id) {
      fetcher.put(`/qr/auth/update_profile`, editFormData)
        .then((res) => {
          showSuccess("Updated successfully")
          setDrawerOpen(false)
          setUser(res?.data?.data)
        })
        .catch((error) => {
          showError(error.response?.data?.message || "Some Error Occured");
        })
        .finally(() => {
          setIsLaoding(false)
        })
    }
  }

  return (
    <>
      <div>
        <div className="flex flex-col items-center mb-6 px-4">
          <ImageUploader
            selectedImage={editFormData?.image}
            setSelectedImage={(file) => {
              setEditFormData((prev) => ({ ...prev, image: file }));
            }}
            error={error}
            setError={setError}
          />

          <p className="text-sm text-gray-500 mt-2">
            Click to change your profile picture
          </p>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Name</label>
          <input
            type="text"
            name="name"
            value={editFormData?.name || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Designation</label>
          <input
            type="text"
            name="title"
            value={editFormData?.title || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Company</label>
          <input
            type="text"
            name="company"
            value={editFormData?.company || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Phone</label>
          <input
            type="text"
            name="telephone"
            value={editFormData?.telephone || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Email</label>
          <input
            type="text"
            name="email"
            value={editFormData?.email || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Address</label>
          <input
            type="text"
            name="address"
            value={editFormData?.address || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">LinkedIn</label>
          <input
            type="text"
            name="linkedin"
            value={editFormData?.linkedin || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-1">Website</label>
          <input
            type="text"
            name="website"
            value={editFormData?.website || ""}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
          />
        </div>
      </div>

      <div className="flex justify-end mt-4">
        <Button
          variant="contained"
          className="!bg-[#8f77c6] !text-white"
          onClick={handleEditForm}
        >
          Save
        </Button>
      </div>
    </>
  );
}
